import React from 'react';
import { SCol, SIcon } from '@avalara/skylab-sdk/react';
const InformationPanel = ({ headingText, content }) => (React.createElement(SCol, { span: '6' },
    React.createElement("h2", { "data-ref": 'buy.returns-thankyou.info-panel.header', className: 'pad-top-lg pad-bottom-sm text-center' }, headingText),
    content.map((bulletText, i) => React.createElement("p", { "data-ref": `buy.returns.thankyou.info-panel.content-${i}`, key: i, className: 'pad-all-xs text-left', style: { width: '100%' } },
        content.length > 1 &&
            React.createElement(SIcon, { name: 'check', className: 'pad-right-xs', "aria-label": 'check mark for bulleted text' }),
        bulletText))));
export default InformationPanel;
